import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "d-flex-center" };
var _hoisted_2 = { class: "fs-18 ml-2" };
import { useStore } from 'vuex';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'OrganizationInfo',
    setup: function (__props) {
        var store = useStore();
        var projectInfo = computed(function () { return store.getters['app/projectInfo']; });
        return function (_ctx, _cache) {
            var _component_el_image = _resolveComponent("el-image");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_el_image, {
                    style: { "height": "40px" },
                    src: _unref(projectInfo).logo
                }, null, 8, ["src"]),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(projectInfo).title), 1)
            ]));
        };
    }
});
